import React from "react";
import "./GetMusicOnLineMusic.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnLineMusic = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select LINE MUSIC Distribution",
    "Music delivered to LINE ecosystem",
    "Reach Japanese & Asian listeners",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>LINE MUSIC Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music to LINE MUSIC and reach millions of listeners across Japan and Asia with FT Tunes."
        />

        <meta
          name="keywords"
          content="LINE Music distribution, distribute music LINE Music, Japan music streaming"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="line-page">

        {/* HERO */}
        <section className="line-hero">
          <Container>

            <img
              src="/Images/line-music-logo.png"
              alt="LINE MUSIC"
              className="line-logo"
            />

            <h1>Distribute Your Music on LINE MUSIC</h1>

            <p>
              Reach millions of fans across Japan and Asia by distributing
              your music on LINE MUSIC — one of the fastest-growing
              streaming platforms.
            </p>

            <Button
              className="gradient-btn-line"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-line"></div>
        </section>


        {/* SHOWCASE */}
        <section className="line-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Expand Your Reach in Asia</h2>

                <p>
                  LINE MUSIC connects artists with millions of active users.
                  Grow your fanbase, increase streams, and build presence
                  in Japan's thriving music market.
                </p>

                <Button
                  className="outline-btn-line"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-line-music.png"
                  alt="get your music on line music"
                  className="line-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="line-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-line">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="line-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on LINE MUSIC
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-line">
                  <h5>Massive Asian Audience</h5>
                  <p>Millions of active listeners.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-line">
                  <h5>Japan Market Access</h5>
                  <p>Strong local music discovery.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-line">
                  <h5>Smart Recommendations</h5>
                  <p>Boost your song visibility.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-line">
                  <h5>Revenue Tracking</h5>
                  <p>Real-time analytics & earnings.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="line-cta">
          <Container>

            <h2>Start Your LINE MUSIC Distribution Today</h2>

            <Button
              className="gradient-btn-line big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnLineMusic;